exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".requestButton-448de{position:absolute !important;right:14px;top:-56px}.attachmentsEmpty-c7045{color:rgba(0,0,0,.5)}.profileAttachments-ce916{padding:24px}", ""]);

// Exports
exports.locals = {
	"requestButton": "requestButton-448de",
	"attachmentsEmpty": "attachmentsEmpty-c7045",
	"profileAttachments": "profileAttachments-ce916"
};